export const ROUTING_PACKS_RESET_STATE = 'PACKS_RESET_STATE';
export const ROUTING_PACKS_CURRENT_ITEM = 'PACKS_CURRENT_ITEM';

export const ROUTING_PACKS_REQUEST_LOADING = 'PACKS_REQUEST_LOADING';
export const ROUTING_PACKS_REQUEST_SUCCESS = 'PACKS_REQUEST_SUCCESS';
export const ROUTING_PACKS_REQUEST_FAILED = 'PACKS_REQUEST_FAILED';

export const ROUTING_PACKS_CURRENT_ACTION = 'PACKS_CURRENT_ACTION';
export const ROUTING_PACKS_RESET_ACTION = 'PACKS_RESET_ACTION';